// extracted by mini-css-extract-plugin
module.exports = {"inputGroup":"input-group_inputGroup__IKqal","error":"input-group_error__6iPWC"};